import { Twitter, Facebook, Linkedin, Link2, Check } from "lucide-react";
import { useState } from "react";

export function SocialShare({ title, orientation = "vertical" }) {
    const [copied, setCopied] = useState(false);
    const url = typeof window !== "undefined" ? window.location.href : "";
    const enc = encodeURIComponent(url);
    const encTitle = encodeURIComponent(title || "");

    const links = [
        { name: "twitter", icon: Twitter, href: `https://twitter.com/intent/tweet?url=${enc}&text=${encTitle}` },
        { name: "facebook", icon: Facebook, href: `https://www.facebook.com/sharer/sharer.php?u=${enc}` },
        { name: "linkedin", icon: Linkedin, href: `https://www.linkedin.com/sharing/share-offsite/?url=${enc}` },
    ];

    const copy = async () => {
        try {
            await navigator.clipboard.writeText(url);
            setCopied(true);
            setTimeout(() => setCopied(false), 1500);
        } catch (e) {}
    };

    const base = orientation === "vertical" ? "flex flex-col gap-2" : "flex flex-row gap-2";
    const btn =
        "w-10 h-10 rounded-full border border-line bg-surface shadow-card text-dim flex items-center justify-center hover:text-accent hover:border-accent/45 hover:bg-accent-soft transition-colors duration-150";

    return (
        <div className={base} data-testid="social-share">
            {links.map((l) => (
                <a
                    key={l.name}
                    href={l.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`Share on ${l.name}`}
                    data-testid={`share-${l.name}`}
                    className={btn}
                >
                    <l.icon size={15} />
                </a>
            ))}
            <button onClick={copy} aria-label="Copy link" data-testid="share-copy" className={btn}>
                {copied ? <Check size={15} className="text-pos" /> : <Link2 size={15} />}
            </button>
        </div>
    );
}
